/**
 * QuickZoomControl - Zoom Presets
 * Geographic bounds for quick navigation to preset regions
 */

export interface ZoomPreset {
  id: string;
  name: string;
  bounds: [[number, number], [number, number]]; // [SW, NE] corners as [lng, lat]
  icon?: 'home' | 'region' | 'park';
}

export const ZOOM_PRESETS: ZoomPreset[] = [
  // Home
  { id: 'home', name: 'Home (NWT)', bounds: [[-141, 60], [-102, 70]], icon: 'home' },

  // Full Regions
  { id: 'nwt-full', name: 'NWT Full', bounds: [[-141, 60], [-102, 70]], icon: 'region' },
  { id: 'alberta', name: 'Alberta', bounds: [[-120, 49], [-110, 60]], icon: 'region' },

  // NWT Fire Regions
  { id: 'south-slave', name: 'South Slave', bounds: [[-120, 59], [-108, 63]], icon: 'region' },
  { id: 'north-slave', name: 'North Slave', bounds: [[-120, 62], [-108, 68]], icon: 'region' },
  { id: 'deh-cho', name: 'Deh Cho', bounds: [[-130, 59], [-117, 65]], icon: 'region' },
  { id: 'sahtu', name: 'Sahtu', bounds: [[-135, 63], [-118, 68]], icon: 'region' },
  { id: 'beaufort-delta', name: 'Beaufort Delta', bounds: [[-141, 66], [-128, 70]], icon: 'region' },

  // Parks
  { id: 'wbnp', name: 'Wood Buffalo NP', bounds: [[-117, 58], [-110, 61]], icon: 'park' },
  { id: 'nnpr', name: 'Nahanni NPR', bounds: [[-129, 60], [-123, 63]], icon: 'park' },
];
